<div class="pharmacologic-action-container">
  <div class="pharmacologic-action-item-container">
    <div class="pharmacologic-action-item-input-container">
      <mat-form-field appearance="outline" class="pharmacologic-action-form-field">
        <mat-label>Pharmacologic action</mat-label>
        <textarea matInput #pharmacologicActionInput 
          [(ngModel)]="pharmacologicAction"  rows="3"
          class="pharmacologicAction pharmacologic-action-item-input"
          (keyup.enter)="updatePharmacologicAction($event)" 
          (keyup.escape)="cancelUpdate()" (blur)="updatePharmacologicAction($event)"></textarea>
        <mat-icon matSuffix (mousedown)="clearPharmacologicActionInputField()">cancel</mat-icon>
      </mat-form-field>
    </div>
    <div class="input-error" *ngIf="hasFieldValidationError('pharmacologicAction')">
        This is a required field.
    </div>
  </div>
  <div class="pharmacologic-action-info pharmacologic-action-info-text">
     Briefly describe the pharmacologic action of this substance. If a detailed description is needed, please attach a file with more information about the pharmacological action of the substance.
  </div>
</div>
